import React from 'react'
import { useDisableBodyScroll } from 'hooks/useDisableBodyScroll'
import Editor from './Editor/Editor'
import { Dialog, DialogContent } from '@components/ui/dialog'
import { cn } from '@/lib/utils'

const EditorModal = ({
  selectedMedia = '',
  tags = null,
  onClose,
  goNext = () => {},
  goBack = () => {},
  imgLoading = false,
  generate = '',
  defaultSelectedModel = null,
  setGenerate = () => {},
}) => {
  useDisableBodyScroll()

  return (
    <Dialog open={true} onOpenChange={(open) => !open && onClose()}>
      <DialogContent
        className={cn(
          'w-[95%] sm:w-[92%] rounded-md sm:min-w-[92%] bg-white h-[85%] sm:h-[80%] md:h-[96%] md:min-w-[95%] p-1 sm:p-2 postupload-modal',
          'flex justify-center items-center'
        )}
      >
        <div
          className="overflow-y-auto bg-white p-1 sm:p-2 w-full md:min-w-[90vw] h-full"
          onClick={(e) => e.stopPropagation()}
        >
          <Editor
            selectedMedia={selectedMedia}
            tags={tags}
            goNext={goNext}
            goBack={goBack}
            imgLoading={imgLoading}
            generate={generate}
            setGenerate={setGenerate}
            defaultSelectedModel={defaultSelectedModel}
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default EditorModal
